<script>
import $ from 'jQuery';
import Teleport from 'vue2-teleport';

export default {
    name: "Modal",
    props: {
        title: {
            type: String,
            required: false,
        },
        size: {
            type: String,
            required: false,
        },
        whiteHeader: {
            type: Boolean,
            reuired: false,
        },
    },
    inheritAttrs: false,
    components: {
        Teleport,
    },
    data() {
        return {
            isOpen: false,
            bsModal: null,
        }
    },
    computed: {
        dialogClass() {
            switch(this.size) {
                case 'sm': return 'modal-sm';
                case 'md': return '';
                case 'lg': return 'modal-lg';
                case 'xl': return 'modal-xl';
                default: return this.size || '';
            }
        }
    },
    mounted() {
        $(this.$el).modal({
            show: false,
            focus: false,
        });
        $(this.$refs.modal).on('hidden.bs.modal', () => {
            this.isOpen = false
        });
        $(this.$refs.modal).on('shown.bs.modal', () => {
            this.isOpen = true
        });
    },
    methods: {
        open() {
            $(this.$refs.modal).modal('show');
        },
        close() {
            $(this.$refs.modal).modal('hide');
        }
    }
}
</script>

<template>
    <Teleport to="#my-page">
        <div class="modal fade" tabindex="-1" role="dialog" aria-modal="true" aria-hidden="true" v-bind="$attrs"
             ref="modal">
            <div class="modal-dialog" :class="dialogClass">
                <div class="modal-content">
                    <div class="modal-header" :class="{'bg-white': whiteHeader}">
                        <h5 class="modal-title">{{ title }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <slot/>
                    </div>
                    <div class="modal-footer" v-if="$slots.footer">
                        <slot name="footer"/>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

